var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          !_vm.loading
            ? _c(
                "div",
                [
                  Object.keys(_vm.drugDetails).length
                    ? [
                        _c(
                          "table",
                          { staticClass: "table table-sm table-hover mt-2" },
                          [
                            _vm._m(1),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              [
                                _vm._l(_vm.drugDetails, function (r, id, i) {
                                  return [
                                    _c("tr", { key: r.drug.id }, [
                                      _c(
                                        "td",
                                        {
                                          attrs: {
                                            rowspan:
                                              r.details.country_data.dimensions
                                                .length + 1,
                                          },
                                        },
                                        [_vm._v(_vm._s(i + 1))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          attrs: {
                                            rowspan:
                                              r.details.country_data.dimensions
                                                .length + 1,
                                          },
                                        },
                                        [
                                          _c(
                                            "v-popover",
                                            {
                                              staticClass: "d-inline",
                                              attrs: {
                                                placement: "bottom",
                                                "auto-hide": true,
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "icon-fa icon-fa-photo pointer",
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "template",
                                                { slot: "popover" },
                                                [
                                                  _vm.drugsImages[r.drug.id]
                                                    ? _c("img", {
                                                        attrs: {
                                                          src: _vm.drugsImages[
                                                            r.drug.id
                                                          ],
                                                          alt: "",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          attrs: {
                                            rowspan:
                                              r.details.country_data.dimensions
                                                .length + 1,
                                          },
                                        },
                                        [
                                          _c("i", [
                                            _vm._v(_vm._s(r.drug.title)),
                                          ]),
                                          _vm._v(" "),
                                          _c("p", [
                                            _c("strong", [
                                              _vm._v(_vm._s(r.drug.en_title)),
                                            ]),
                                          ]),
                                          _vm._v(" "),
                                          _c("p", [_vm._v(_vm._s(r.drug.id))]),
                                          _vm._v(" "),
                                          r.drug.pack_box_comment
                                            ? _c(
                                                "p",
                                                { staticClass: "text-muted" },
                                                [
                                                  _vm._m(2, true),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        r.drug.pack_box_comment
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          +r.drug.pack_set > 1
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "alert alert-info p-1",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    Делать замеры комплекта "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v(
                                                      "x " +
                                                        _vm._s(+r.drug.pack_set)
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(
                                      r.details.country_data.dimensions,
                                      function (d) {
                                        return _c("tr", [
                                          _c("td", [
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: d.int_value,
                                                    expression: "d.int_value",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: { disabled: d.saved },
                                                on: {
                                                  change: [
                                                    function ($event) {
                                                      var $$selectedVal =
                                                        Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function (o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function (o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                      _vm.$set(
                                                        d,
                                                        "int_value",
                                                        $event.target.multiple
                                                          ? $$selectedVal
                                                          : $$selectedVal[0]
                                                      )
                                                    },
                                                    function ($event) {
                                                      return _vm.updateRecord(
                                                        r.drug.id
                                                      )
                                                    },
                                                  ],
                                                },
                                              },
                                              [
                                                _c(
                                                  "option",
                                                  {
                                                    attrs: {
                                                      value: "0",
                                                      disabled: "",
                                                    },
                                                  },
                                                  [_vm._v("Выберите страну")]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.$AllCountries,
                                                  function (c) {
                                                    return _c(
                                                      "option",
                                                      {
                                                        domProps: {
                                                          value: c.id,
                                                        },
                                                      },
                                                      [_vm._v(_vm._s(c.name))]
                                                    )
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            _vm._l(
                                              _vm.getTitleByCountry(
                                                +d.int_value,
                                                r.details.country_data?.title ??
                                                  []
                                              ),
                                              function (t) {
                                                return _c("p", [
                                                  _vm._v(_vm._s(t)),
                                                ])
                                              }
                                            ),
                                            0
                                          ),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: d.array_value.width,
                                                  expression:
                                                    "d.array_value.width",
                                                },
                                              ],
                                              staticClass: "form-control max_w",
                                              attrs: {
                                                type: "text",
                                                placeholder: "ширина",
                                              },
                                              domProps: {
                                                value: d.array_value.width,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.updateRecord(
                                                    r.drug.id
                                                  )
                                                },
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    d.array_value,
                                                    "width",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: d.array_value.height,
                                                  expression:
                                                    "d.array_value.height",
                                                },
                                              ],
                                              staticClass: "form-control max_w",
                                              attrs: {
                                                type: "text",
                                                placeholder: "высота",
                                              },
                                              domProps: {
                                                value: d.array_value.height,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.updateRecord(
                                                    r.drug.id
                                                  )
                                                },
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    d.array_value,
                                                    "height",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: d.array_value.depth,
                                                  expression:
                                                    "d.array_value.depth",
                                                },
                                              ],
                                              staticClass: "form-control max_w",
                                              attrs: {
                                                type: "text",
                                                placeholder: "глубина",
                                              },
                                              domProps: {
                                                value: d.array_value.depth,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.updateRecord(
                                                    r.drug.id
                                                  )
                                                },
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    d.array_value,
                                                    "depth",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: d.array_value.weight,
                                                  expression:
                                                    "d.array_value.weight",
                                                },
                                              ],
                                              staticClass: "form-control max_w",
                                              attrs: {
                                                type: "text",
                                                placeholder: "вес",
                                              },
                                              domProps: {
                                                value: d.array_value.weight,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.updateRecord(
                                                    r.drug.id
                                                  )
                                                },
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    d.array_value,
                                                    "weight",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]),
                                        ])
                                      }
                                    ),
                                  ]
                                }),
                              ],
                              2
                            ),
                          ]
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h4", [_vm._v("Препараты в наличии на складе")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("#")]),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("страна")]),
        _vm._v(" "),
        _c("th", [_vm._v("название в стране")]),
        _vm._v(" "),
        _c("th", [_vm._v("ширина (мм)")]),
        _vm._v(" "),
        _c("th", [_vm._v("высота (мм)")]),
        _vm._v(" "),
        _c("th", [_vm._v("глубина (мм)")]),
        _vm._v(" "),
        _c("th", [_vm._v("вес (гр)")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "badge badge-info" }, [
      _c("i", { staticClass: "icon-fa icon-fa-info" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }